import { DESCRICAO_PERFIS } from '@metaepi/shared';
import { ChevronDown, KeyRound, LogOut, UserRound } from 'lucide-react';
import { useEffect, useId, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { useSessao } from '../features/auth/contexto';

/** Menu da conta (nome, perfil, trocar senha, sair). Abre com clique/Enter; fecha com Esc. */
export function MenuUsuario() {
  const { conta, sair } = useSessao();
  const navegar = useNavigate();
  const [aberto, setAberto] = useState(false);
  const idMenu = useId();
  const raiz = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!aberto) return;
    const fechar = (e: MouseEvent | KeyboardEvent) => {
      if (
        e instanceof KeyboardEvent ? e.key === 'Escape' : !raiz.current?.contains(e.target as Node)
      )
        setAberto(false);
    };
    document.addEventListener('mousedown', fechar);
    document.addEventListener('keydown', fechar);
    return () => {
      document.removeEventListener('mousedown', fechar);
      document.removeEventListener('keydown', fechar);
    };
  }, [aberto]);

  if (!conta) return null;
  const { nome, perfil } = conta.usuario;

  return (
    <div ref={raiz} className="relative">
      <button
        type="button"
        aria-expanded={aberto}
        aria-controls={idMenu}
        onClick={() => setAberto(!aberto)}
        className="flex h-11 items-center gap-2 rounded-lg border border-borda px-3 text-sm font-medium text-texto hover:bg-superficie-2"
      >
        <UserRound className="size-4" aria-hidden="true" />
        <span className="hidden max-w-40 truncate md:inline">{nome}</span>
        <span className="sr-only md:hidden">Minha conta</span>
        <ChevronDown className="size-4" aria-hidden="true" />
      </button>
      {aberto && (
        <div
          id={idMenu}
          className="absolute right-0 z-40 mt-2 w-64 rounded-xl border border-borda bg-superficie p-2 shadow-lg"
        >
          <div className="border-b border-borda px-3 pb-2">
            <p className="truncate font-semibold text-texto">{nome}</p>
            <p className="text-sm text-texto-suave">{DESCRICAO_PERFIS[perfil].rotulo}</p>
          </div>
          <ul className="pt-2">
            <li>
              <Link
                to="/conta/senha"
                onClick={() => setAberto(false)}
                className="flex min-h-11 items-center gap-2 rounded-lg px-3 text-sm text-texto hover:bg-superficie-2"
              >
                <KeyRound className="size-4" aria-hidden="true" />
                Trocar senha
              </Link>
            </li>
            <li>
              <button
                type="button"
                onClick={async () => {
                  await sair();
                  navegar('/entrar?motivo=saiu', { replace: true });
                }}
                className="flex min-h-11 w-full items-center gap-2 rounded-lg px-3 text-left text-sm text-texto hover:bg-superficie-2"
              >
                <LogOut className="size-4" aria-hidden="true" />
                Sair
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
